import centroid from '@turf/centroid';
import { AllGeoJSON } from '@turf/helpers';
import { theme } from 'aimo-ui';
import useSelectParkingZone from 'hooks/useSelectParkingZone';
import React from 'react';
import { useActiveElementStore } from '../../stores/activeElementStore';
import { AimoPolygonProps, LatLng } from '../../types/MapTypes';
import { makePoint, mapGeoJSONToPolygonArray } from '../../utils/mapUtils';
import Polygon from './RNWeb/Polygon';

// Dark green color for the border
const DARKER_GREEN = theme.colors.boost.green; // #008939
// Original color for the fill
const PRIMARY = theme.colors.primary;

const AimoPolygon = ({
  id,
  geoJsonMultiPolygon,
  testID,
  hidden,
  onPress,
}: AimoPolygonProps) => {
  // Select the comparison, not the uid: one polygon is rendered per zone, so
  // subscribing to the raw uid re-renders every polygon on any selection change.
  const isActive = useActiveElementStore((state) => state.activeElement === id);
  const { handleParkZoneSelected } = useSelectParkingZone();

  const centerOfPolygon = (index: number) => {
    const selectedPolygon = [...geoJsonMultiPolygon.coordinates[index]];
    const singleGeoJsonObj: AllGeoJSON = {
      type: 'MultiPolygon',
      coordinates: [selectedPolygon],
    };
    const geoJsonCenter = centroid(singleGeoJsonObj);
    return makePoint(geoJsonCenter?.geometry?.coordinates);
  };

  const polygons = React.useMemo(
    () => mapGeoJSONToPolygonArray(geoJsonMultiPolygon.coordinates),
    [geoJsonMultiPolygon.coordinates]
  );

  return (
    <>
      {polygons.map((polygonArray: LatLng[], index: number) => {
        return (
          <Polygon
            key={`${testID}-${index}`}
            paths={polygonArray}
            testid={`${testID}-${index}`}
            strokeColor={DARKER_GREEN}
            strokeOpacity={isActive ? 1 : 0.6}
            strokeWeight={isActive ? 3 : 1}
            fillColor={PRIMARY}
            onPress={() => {
              if (hidden) {
                return;
              }
              if (onPress) {
                onPress();
              } else {
                handleParkZoneSelected(id, centerOfPolygon(index));
              }
            }}
          />
        );
      })}
    </>
  );
};

export default AimoPolygon;
